export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70acbe6456540ba1ba8ed9c1cf9d554be7feccb95d&name=pushAdClickData!'